<template>
  <v-container fluid>
    <div class="login-wrapper">
      <v-form id="login-form" @submit.prevent="login" class="login px-5 py-3">
        <v-img max-width="250" v-show="$vuetify.breakpoint.mdAndUp" src="/img/veroFresh.png" />
        <div class="login-inputs">
          <div class="validate-group py-2">
            <v-text-field
              prepend-inner-icon="mdi-account"
              id="email"
              :error-messages="emailErrors"
              v-model="email"
              :placeholder="$t('email')"
              solo
            />
          </div>
          <div v-if="messages.basicAuthError" class="login-error py-1">
            {{ messages.basicAuthError }}
          </div>
          <v-btn type="submit" class="mx-auto my-2">
            <v-icon>mdi-login</v-icon>
            {{ $t('log_in_display') }}
          </v-btn>
        </div>
      </v-form>
      <!-- Modal -->
      <v-dialog v-model="showModal" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            {{ $t('waiting_for_authorization') }}
          </v-card-title>
          <v-card-text>
            <p class="my-4">
              {{ $t('check_email_and_click_link') }}
              <v-progress-circular indeterminate size="24" class="ml-2"></v-progress-circular>
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="cancelPolling">
              {{ $t('cancel') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import ValidationMixin from '@/components/mixins/ValidationMixin'
import UrlHelper from '@/util/Url'
import AuthUtil from '@/util/AuthUtil'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'TVLogin',
  mixins: [ValidationMixin],
  data() {
    return {
      url: `${UrlHelper.getApiUrl()}/auth`,
      email: null,
      sendingLogin: false,
      polling: false,
      showModal: false,
      messages: {
        basicAuthError: null,
        otpAuthError: null,
        otpInfoMessage: null,
      },
    }
  },
  validations: {
    email: {
      required,
    },
  },
  computed: {
    emailErrors() {
      return this.validationErrors([
        {
          prop: this.$v.email,
          rule: 'required',
          message: this.$t('email_required'),
        },
      ])
    },
  },
  methods: {
    async login() {
      this.clearMessages()
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false
      }
      this.sendingLogin = true
      const requestConfig = {
        email: this.email,
      }
      const response = await axios
        .post(`${this.url}/send-tv-link`, requestConfig)
        .catch((err) => err.response)
        .finally(() => {
          this.sendingLogin = false
        })
      if (response.status === 201) {
        this.showModal = true
        this.polling = true
        const tvp = response.data.tvp
        this.pollForEmailClick(tvp)
      } else {
        this.messages.basicAuthError = this.$i18n.t('login_error')
      }
    },
    async pollForEmailClick(tvp) {
      while (this.polling) {
        try {
          const response = await axios.post(`${this.url}/poll-tv-token`, { tvp })
          if (response.status === 200) {
            this.polling = false
            this.showModal = false
            const jwt = AuthUtil.parseJwt(response)
            AuthUtil.login(jwt, true)
          }
        } catch (err) {
          console.error('Polling error:', err)
        }
        await new Promise((resolve) => setTimeout(resolve, 5000))
      }
    },
    cancelPolling() {
      this.polling = false
      this.showModal = false
    },
    clearMessages() {
      this.messages = {
        basicAuthError: null,
        otpAuthError: null,
        otpInfoMessage: null,
      }
    },
  },
}
</script>

<style scoped lang="scss">
.login-error {
  color: red;
}

.login .btn-link {
  font-size: smaller;
}

.security-code-message {
  font-size: 0.75rem;
}

input::placeholder {
  color: rgb(128, 128, 128);
}

.reset-password-info {
  font-size: 0.85em;
  color: gray;
}

.centered-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.centered-modal .modal-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}
</style>
